/**
 * Extrait l'apiCode (sous-domaine) depuis le hostname du navigateur.
 * Retourne null si le hostname n'a pas de sous-domaine.
 *
 * Exemples :
 *   'david.localhost:3000' → 'david'
 *   'demo.comete.app'      → 'demo'
 *   'localhost:3000'        → null
 */
export function parseApiCodeFromHost(host: string): string | null {
  const hostname = host.split(':')[0];
  const parts = hostname.split('.');
  return parts.length > 1 ? parts[0] : null;
}
